<script>
  /**
 *
 *
 */

  /*                */
  const { rawPricing = {} } = $props();

  const extraParm = $derived({
    ...(rawPricing.fromPrice ? { 'is-starting-price': true } : {})
  });
</script>

<ofc-pricing-item-v1
  class="reco_cinema__price"
  meta-team="ft6bcn"
  display-size="50"
  retail-price={rawPricing.retailPrice}
  display-alignment="right"
  {...extraParm}
  old-price={rawPricing.oldPrice}
  suggested-retail-price={rawPricing.suggestedRetailPrice}
  data-testid="pricing_item">
</ofc-pricing-item-v1>
